module.exports = __webpack_public_path__ + "icon-128-visualisation-scatter.png";


//////////////////
// WEBPACK FOOTER
// ./src/styles/img/icon-128-visualisation-scatter.png
// module id = 634
// module chunks = 11